import { isRouteErrorResponse, useRouteError } from "react-router";

import { errorHandler } from "../../helpers/errorHandler";

export const ErrorPage = () => {
	const error = useRouteError();
	errorHandler(error, { tags: { source: "ErrorPage" } });

	if (isRouteErrorResponse(error)) {
		return (
			<div
				id="error-page"
				className="tw:flex tw:h-dvh tw:flex-col tw:items-center tw:justify-center tw:text-center tw:text-2xl tw:text-noComponentGray-text"
			>
				<h1 className="tw:text-4xl tw:font-bold tw:text-black">Oops!</h1>
				<h2 className="tw:text-2xl tw:font-bold tw:text-black">{`${error.status} - ${error.statusText}`}</h2>
				<div className="tw:mt-4 tw:text-base">
					{error.error?.message ? (
						<h3>{`Sorry, ${error.error.message}`}</h3>
					) : (
						<h3>Sorry, an unexpected error has occurred.</h3>
					)}
				</div>
			</div>
		);
	}

	return (
		<div
			id="error-page"
			className="tw:flex tw:h-dvh tw:flex-col tw:items-center tw:justify-center tw:text-center tw:text-2xl tw:text-noComponentGray-text"
		>
			<h1 className="tw:text-4xl tw:font-bold tw:text-black">Oops!</h1>
			<h2 className="tw:text-base tw:font-bold tw:text-black tw:md:text-2xl">
				Sorry, an unexpected error has occurred.
			</h2>
		</div>
	);
};
